const projectsArray = [
    {
        name: "Zoop",
        tech: "Java",
        image: "https://raw.githubusercontent.com/GavinStirling/gavinstirling-portfolio-v2/main/src/assets/images/projects/zoop-preview.png",
        description: " Java command line project which manages a user and a zoo of animals. Currently lions and magpies. It makes use of Object Orieted Programming concepts, being abstraction, encapsulation, inheritance and polymorphism.  ",
        githubLink: "https://github.com/GavinStirling/zoop",
        deployedLink: "https://github.com/GavinStirling/zoop"
    },
    {
        name: "Card Game",
        tech: "Java",
        image: "https://raw.githubusercontent.com/GavinStirling/gavinstirling-portfolio-v2/main/src/assets/images/projects/cardgame-preview.png",
        description: " Java command line project which simulates a card game. The first game interacts with a deck of cards, the second game is a one player version of snap and the third is a two player version of snap. ",
        githubLink: "https://github.com/GavinStirling/card-game",
        deployedLink: "https://github.com/GavinStirling/card-game"
    },
    {
        name: "Greetings API",
        tech: "Java, Springboot",
        image: "https://raw.githubusercontent.com/GavinStirling/gavinstirling-portfolio-v2/main/src/assets/images/projects/greetingapi.png",
        description: " This is a RESTful API which is built using Springboot. The API creates, reads, updates and deletes greetings and communicates with a database. ",
        githubLink: "https://github.com/GavinStirling/greetingAPI",
        deployedLink: "https://github.com/GavinStirling/greetingAPI"
    },
    {
        name: "FX Tech Test",
        tech: "Java, Springboot",
        image: "https://raw.githubusercontent.com/GavinStirling/gavinstirling-portfolio-v2/main/src/assets/images/projects/techtest.png",
        description: " The test was to build a piece of a RESTful API which was completed using Springboot. The objective of this code is to receive a CSV message which contains information relating to a FX price. ",
        githubLink: "https://github.com/GavinStirling/santander-tech-test",
        deployedLink: "https://github.com/GavinStirling/santander-tech-test"
    },
    {
        name: "Beers! - Punk API",
        tech: "React",
        image: "https://raw.githubusercontent.com/GavinStirling/gavinstirling-portfolio-v2/main/src/assets/images/projects/beers-preview.png",
        description:
            " React project using the Punk API as a datasource. \n\n The focus was on using an API, useState and useEffect. ",
        githubLink: "https://github.com/GavinStirling/beers-app",
        deployedLink: "https://gavinstirling.github.io/beers-app/",
    },
    {
        name: "Connect Four",
        tech: "HTML, SCSS, Javascript",
        image: "https://raw.githubusercontent.com/GavinStirling/gavinstirling-portfolio-v2/main/src/assets/images/projects/connect-four-preview.png",
        description:
            "My version of the connect four game made using JavaScript. \n\n It makes use of a nested array to track two players who drop discs into columns with the aim to connect four in a row of the same colour. ",
        githubLink: "https://github.com/GavinStirling/connect-four",
        deployedLink: "https://gavinstirling.github.io/connect-four/",
    },
    {
        name: "Basic Calculator",
        tech: "HTML, SCSS, Javascript",
        image: "https://raw.githubusercontent.com/GavinStirling/gavinstirling-portfolio-v2/main/src/assets/images/projects/calculator-preview.png",
        description:
            "This is my calculator which was built using Javascript and was also tested end-to-end using Cypress.\n\n I focused on the BEM naming principles while building this calculator to ensure best practices were taken into account when styling. ",
        githubLink: "https://github.com/GavinStirling/calculator",
        deployedLink: "https://gavinstirling.github.io/calculator/",
    },
    {
        name: "Ticket Tracker",
        tech: "React",
        image: "https://raw.githubusercontent.com/GavinStirling/gavinstirling-portfolio-v2/main/src/assets/images/projects/ticket-tracker-desktop.png",
        description:
            " The goal of this project was to create an application to track the amount if tickets completed by the employees. \n\n It demonstrates the use of useState in React.",
        githubLink: "https://github.com/GavinStirling/ticket-tracker",
        deployedLink: "https://gavinstirling.github.io/ticket-tracker/",
    },
    {
        name: "First Portfolio",
        tech: "HTML, CSS",
        image: "https://raw.githubusercontent.com/GavinStirling/gavinstirling-portfolio-v2/main/src/assets/images/projects/first-portfolio-preview.png",
        description:
            "This was the first version of my portfolio website which was built using straight html and css. This was the first project which I completed. \n\n It was maintained for a while until this new portfolio was built using React.js. ",
        githubLink: "https://github.com/GavinStirling/portfolio-website",
        deployedLink: "https://gavinstirling.github.io/portfolio-website/",
    }
    
];

export default projectsArray;
